import { ApiErrorData, ApiResponse } from 'models/ApiResponse';
import { ReportSummaryRow } from 'models/ReportSummaryRow';

import { FunctionsHelper } from 'utils/FunctionsHelper';
import MainBackendAxios from 'utils/MainBackendAxios';

export const DiReportService = {
  getSummary: async (
    body: GetSummaryReportRequestDto
  ): Promise<ApiResponse<ReportSummaryRow[] | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/di/report/get-summary`,
        body
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getXlsxSummary: async (
    body: GetSummaryReportRequestDto
  ): Promise<ApiResponse<{ blob: Blob; filename: string } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/di/report/get-xlsx-summary`,
        body,
        { responseType: 'blob' }
      );

      let filename = FunctionsHelper.generateUniqueId() + '.xlsx';
      const contentDispositionHeader = response.headers['content-disposition'];

      if (contentDispositionHeader) {
        const matches = contentDispositionHeader.match(/filename="?([^"]+)"?/);
        if (matches && matches[1]) {
          filename = matches[1];
        }
      }

      return {
        success: true,
        status: response.status,
        data: {
          blob: response.data,
          filename: filename,
        },
      };
    } catch (err) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getCsvConsolidated: async (
    body: GetCsvConsolidatedRequestDto
  ): Promise<ApiResponse<{ blob: Blob; filename: string } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/di/report/get-csv-consolidated`,
        body,
        { responseType: 'blob' }
      );

      let filename = FunctionsHelper.generateUniqueId() + '.csv';
      const contentDispositionHeader = response.headers['content-disposition'];

      if (contentDispositionHeader) {
        const matches = contentDispositionHeader.match(/filename="?([^"]+)"?/);
        if (matches && matches[1]) {
          filename = matches[1];
        }
      }

      console.log('filename', filename);

      return {
        success: true,
        status: response.status,
        data: {
          blob: response.data,
          filename: filename,
        },
      };
    } catch (err) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};

export interface GetSummaryReportRequestDto {
  type: 'MONTHLY' | 'DAILY';
  category: 'CARRIER' | 'SKU' | 'STORE';
  metric: 'SELLOUT_QTY' | 'STOCK_QTY' | 'SELLOUT_AMOUNT';
  startDate: string; //En caso sea de tipo MONTHLY se envía el primer día del año. ej. 2023-01-01
  endDate: string; //En caso sea de tipo MONTHLY se envía el último día del año. ej. 2023-12-31
}

export interface GetCsvConsolidatedRequestDto {
  startDate: string; //YYYY-MM-DD
  endDate: string;
}
